const Loading = () => {
	return (
		<div className="wrapper-loader">
			<div className="loader"></div>
		</div>
	);
};

export default Loading;
